import { render } from "./detailEdit.vue?vue&type=template&id=24910156&scoped=true"
import script from "./detailEdit.vue?vue&type=script&lang=js"
export * from "./detailEdit.vue?vue&type=script&lang=js"

import "./detailEdit.vue?vue&type=style&index=0&id=24910156&lang=scss&scoped=true"

import exportComponent from "C:\\wamp64\\www\\DDP\\webapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24910156"]])

export default __exports__